import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";

// Custom GuMi wordmark — a small geometric "g" mark + custom-spaced wordmark
export const Logo = ({ className = "", inverse = false }) => {
  const ink = inverse ? "#F9F8F6" : "#0B1B3D";
  const navigate = useNavigate();
  const { user } = useAuth();
  const destination = user ? "/dashboard" : "/";

  return (
    <a
      href={destination}
      data-testid="brand-logo"
      className={`inline-flex items-center gap-2 font-heading ${className}`}
      aria-label={user ? "GuMi, go to dashboard" : "GuMi, go to home"}
      onClick={(e) => {
        e.preventDefault();
        navigate(destination);
      }}
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="1" y="1" width="22" height="22" rx="6" stroke={ink} strokeWidth="1.5" />
        <path
          d="M8.5 9.2c0-1.7 1.6-2.9 3.6-2.9 1.6 0 3 .9 3 .9M15.5 11v3.4c0 1.9-1.6 3.3-3.7 3.3-2 0-3.3-1-3.6-2.4"
          stroke={ink}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <circle cx="15.5" cy="11" r="1.1" fill="#0F766E" />
      </svg>
      <span
        className="text-[18px] font-semibold tracking-[-0.02em]"
        style={{ color: ink }}
      >
        GuMi
      </span>
    </a>
  );
};

export default Logo;
